/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignLearningToSubjectDTO
 */
export interface AssignLearningToSubjectDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignLearningToSubjectDTO
     */
    learningIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssignLearningToSubjectDTO
     */
    subjectId?: string;
}

export function AssignLearningToSubjectDTOFromJSON(json: any): AssignLearningToSubjectDTO {
    return AssignLearningToSubjectDTOFromJSONTyped(json, false);
}

export function AssignLearningToSubjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignLearningToSubjectDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'learningIds': !exists(json, 'learningIds') ? undefined : json['learningIds'],
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
    };
}

export function AssignLearningToSubjectDTOToJSON(value?: AssignLearningToSubjectDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'learningIds': value.learningIds,
        'subjectId': value.subjectId,
    };
}

